import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../../_services/_nav.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { AutenticacionService } from '../../../_services/autenticacion.service';
import { Producto } from '../../../_models/producto';
import { ProductoSeguroAnalizamosService } from '../../../_services/producto-seguro-analizamos.service';
import { ProductoSeguroAnalizamos } from '../../../_models/producto-seguro-analizamos';
import { Seguro } from '../../../_models/seguro';
import { forkJoin } from 'rxjs';
import { SeguroService } from '../../../_services/seguro.service';
import { ProductoSeguroTipoConstruccionService } from '../../../_services/producto-seguro-tipo-construccion.service';
import { ProductoSeguroTipoDireccionService } from '../../../_services/producto-seguro-tipo-direccion.service';
import { ProductoSeguroClaseViviendaService } from '../../../_services/producto-seguro-clase-vivienda.service';
import { ProductoSeguroTipoDireccion } from '../../../_models/producto-seguro-tipo-direccion';
import { ProductoSeguroTipoConstruccion } from '../../../_models/producto-seguro-tipo-construccion';
import { ProductoSeguroClaseVivienda } from '../../../_models/producto-seguro-clase-vivienda';
import { ListaService } from '../../../_services/lista.service';
import {SegurosBienesTipoConstruccionService} from '../../../_services/seguros-bienes-tipo-construccion.service';

@Component( {
  selector: 'app-producto-seguro-analizamos',
  templateUrl: 'producto-seguro-analizamos.component.html'
} )

export class ProductoSeguroAnalizamosComponent implements OnInit {

  @Input() producto: Producto;
  @Input() editar: Boolean = false;
  carInformacionInicial = true;
  guardando = false;
  lisProductosSegurosTodos: ProductoSeguroAnalizamos[] = [];
  lisSegurosTodos: Seguro[] = [];
  lisSeguros: SelectItem[] = [];
  formulario: FormGroup;
  submitted = false;
  carTabla = true;
  columnas: any[];
  lisTipoDireccion: SelectItem[] = [];
  lisTipoConstruccion: SelectItem[] = [];
  lisClaseVivienda: SelectItem[] = [];
  lisTipoOcupacion: SelectItem[] = [];
  selectClaseVivienda: SelectItem[] = [];
  listaTipoMetodoPago: SelectItem[] = [];
  lisProductoSeguroTipoDireccion: ProductoSeguroTipoDireccion[] = [];
  lisProductoSeguroTipoConstruccion: ProductoSeguroTipoConstruccion[] = [];
  lisProductoSeguro: ProductoSeguroAnalizamos[] = [];

  constructor( private serProductoSeguro: ProductoSeguroAnalizamosService,
               private serSeguro: SeguroService,
               private navServicio: NavService,
               private route: ActivatedRoute,
               private location: Location,
               private fb: FormBuilder,
               private autServicio: AutenticacionService,
               private proSeguroTipoConstruccionService: ProductoSeguroTipoConstruccionService,
               private proSeguroTipoDireccionService: ProductoSeguroTipoDireccionService,
               private proSeguroClaseViviendaService: ProductoSeguroClaseViviendaService,
               private lisService: ListaService,
               private conServicio: ConfirmationService,
               private segurosBienesTipoConstruccionService: SegurosBienesTipoConstruccionService) {
  }

  ngOnInit(): void {
    if ( this.producto && this.producto.idProducto ) {
      forkJoin( this.serProductoSeguro.listadoPorProducto( this.producto.idProducto ),
        this.serSeguro.listadoEnabled(),
        this.proSeguroTipoConstruccionService.listadoPorProducto( this.producto.idProducto ),
        this.proSeguroTipoDireccionService.listadoPorProducto( this.producto.idProducto ),
        this.lisService.getMasterDetails( 'ListasClasesViviendas' ),
        this.lisService.getMasterDetails( 'ListasTiposDirecciones' ),
        this.lisService.getMasterDetails( 'ListasTiposOcupaciones' ),
        this.lisService.getMasterDetails( 'ListasTiposMetodosPagoSeguros' ),
      ).subscribe( ( [ productosSeguros, seguros,  lisProductoTipoConstruccion, lisProductoTipoDireccion, lisClaseVivienda, lisTipoDireccion, lisTipoOcupaciones, lisTipoMetodoPago ] ) => {
        this.lisProductosSegurosTodos = productosSeguros;
        this.lisSegurosTodos = seguros;
        this.lisProductoSeguroTipoConstruccion = lisProductoTipoConstruccion;
        this.lisProductoSeguroTipoDireccion = lisProductoTipoDireccion;
        this.lisClaseVivienda = lisClaseVivienda.map( s => ( { label: s.nombre, value: s.idLista } ) );
        this.lisTipoDireccion = lisTipoDireccion.map( s => ( { label: s.nombre, value: s.idLista } ) );
        this.lisTipoOcupacion = lisTipoOcupaciones.map( s => ( { label: s.nombre, value: s.idLista } ) );
        this.listaTipoMetodoPago = lisTipoMetodoPago.map( s => ( { label: s.nombre, value: s.idLista } ) );
        this.lisTipoDireccion.unshift( { label: this.navServicio.buscarMensaje( 'LBL_SELECCIONE' ), value: null } );
        this.ordenarSeguros();
        this.cargarListado();
        this.cargarSeguros();
        this.carServiciosIniciales();
      } );
    }
  }

  cargarListado() {
    this.lisProductoSeguro = [];
    this.lisProductosSegurosTodos.forEach( e => {
      if ( e.indicadorHabilitado ) {
        const tiposDirecciones = this.lisProductoSeguroTipoDireccion.filter( x => x.indicadorHabilitado && x.idProductoSeguro === e.idProductoSeguro );
        const tiposConstrucciones = this.lisProductoSeguroTipoConstruccion.filter( x => x.indicadorHabilitado && x.idProductoSeguro === e.idProductoSeguro );
        e.tipoDireccion = tiposDirecciones.map( s => s.tipoDireccion ).join( ',' );
        e.tipoConstruccion = tiposConstrucciones.map( s => s.tipoConstruccionVivienda ).join( ',' );
        this.lisProductoSeguro.push( e );
      }
    } );
  }

  ordenarSeguros() {
    this.lisProductosSegurosTodos.sort( ( a, b ) => new Date( b.auditoriaFecha ).getTime() - new Date( a.auditoriaFecha ).getTime() );
  }

  cargarSeguros() {
    this.lisSeguros = [];
    let lista: ProductoSeguroAnalizamos[] = [];
    this.lisSegurosTodos.forEach( e => {
      lista = this.lisProductoSeguro.filter( x => x.idSeguro === e.idSeguro && x.idClaseVivienda);
      if(lista.length < this.lisClaseVivienda.length){
        this.lisSeguros.push( { label: e.nombre, value: e.idSeguro } );
      }
    });
  }

  validarTipoVivienda1(){
    this.selectClaseVivienda = [];
    let lista: ProductoSeguroAnalizamos[];
    lista = this.lisProductoSeguro.filter( x => x.idSeguro === this.f.idSeguro.value );
    this.lisClaseVivienda.forEach( e => {
      if( !lista.find( x => x.idClaseVivienda === e.value && x.tipoConstruccion !== "" ) ){
        this.selectClaseVivienda.push( { label: e.label, value: e.value } );
      }
    });
  }


  async validarTipoVivienda(): Promise<void> {
    this.selectClaseVivienda = [];

    try {
      this.f.idTipoConstruccion.setValue(null);
      this.lisTipoConstruccion = [];

      const lisTipoConstruccion = await this.segurosBienesTipoConstruccionService
        .listadoPorIdSeguro(this.f.idSeguro.value)
        .toPromise();

      this.lisTipoConstruccion = lisTipoConstruccion.map(s => ({
        label: s.nombreTipoConstruccion,
        value: s.idListaTipoConstruccionVivienda
      }));


    } catch (error) {
      console.error('Error al obtener tipos de construcción:', error);
    }

    let lista: ProductoSeguroAnalizamos[];
    lista = this.lisProductoSeguro.filter(x => x.idSeguro === this.f.idSeguro.value);

    this.lisClaseVivienda.forEach(e => {
      if (!lista.find(x => x.idClaseVivienda === e.value && x.tipoConstruccion !== "")) {
        this.selectClaseVivienda.push({ label: e.label, value: e.value });
      }
    });
  }

  carServiciosIniciales() {
    this.columnas = [
      { field: 'codigoSeguro', header: this.navServicio.buscarMensaje( 'SEGURO.LBL_CODIGO' ), sort: true },
      { field: 'nombreSeguro', header: this.navServicio.buscarMensaje( 'SEGURO.LBL_NOMBRE' ), sort: true },
      { field: 'indicadorBeneficiariosSeguro', header: this.navServicio.buscarMensaje( 'SEGURO.LBL_BENEFI' ), sort: true },
      { field: 'nombreCuestionarioSeguro', header: this.navServicio.buscarMensaje( 'SEGURO.LBL_DECLRIES' ), sort: true },
      {
        field: 'indicadorAplicaConfiguracionAdicional',
        header: this.navServicio.buscarMensaje( 'SEGURO.LBL_APLICACONFIGURACIONADICIONAL' ),
        sort: true
      },
      { field: 'tipoDireccion', header: this.navServicio.buscarMensaje( 'SEGURO.LBL_TIPODIRECCION' ), sort: true },
      { field: 'claseVivienda', header: this.navServicio.buscarMensaje( 'SEGURO.LBL_TIPOVIVIENDA' ), sort: true },
      { field: 'tipoConstruccion', header: this.navServicio.buscarMensaje( 'SEGURO.LBL_TIPOCONSTRUCCION' ), sort: true },
      { field: 'tipoOcupacion', header: this.navServicio.buscarMensaje( 'SEGURO.LBL_TIPOOCUPACION' ), sort: true },
      { field: 'tipoMetodoPago', header: this.navServicio.buscarMensaje( 'SEGURO.LBL_METODOPAGO' ), sort: true },
      { field: 'indicadorEnviar', header: this.navServicio.buscarMensaje( 'SEGURO.LBL_ENVIAR' ), sort: true },
      { field: 'indicadorObligatorio', header: this.navServicio.buscarMensaje( 'PRODUCTO.LBL_OBLIGATORIO' ), sort: true },
      { field: 'indicadorNoEliminable', header: this.navServicio.buscarMensaje( 'SEGURO.LBL_NOELIMINABLE' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true },

      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.cargarFormulario();
    this.carTabla = false;
    this.carInformacionInicial = false;
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idProducto: [ this.producto.idProducto, [ Validators.required ] ],
      idSeguro: [ null, [ Validators.required ] ],
      indicadorObligatorio: [ false ],
      indicadorNoEliminable: [ false ],
      indicadorAplicaConfiguracionAdicional: [ false ],
      indicadorEnviar: [ false ],
      idTipoConstruccion: [ [] ],
      idClaseVivienda: [ null ],
      idTipoDireccion: [ null ],
      idTipoOcupacion: [ null ],
      idTipoMetodoPago: [  null, [ Validators.required ]],
      indicadorHabilitado: [ true, [ Validators.required ] ]
    } );
  }

  onSubmit() {
    this.submitted = true;
    if ( !this.formulario.valid ) {
      return;
    }

    const registro = this.formulario.value;
    const obligatorio = this.lisProductoSeguro.find( x => x.indicadorObligatorio );
    if ( !registro.indicadorObligatorio && !obligatorio ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'SEGURO.MSG_OBLIGATORIO' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'p-seguros-aceptar',
        accept: () => {
        },
        reject: () => {
        }
      } );
      return;
    }

    if ( registro.indicadorObligatorio && !!obligatorio ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'SEGURO.MSG_EXISTEOBLIGATORIO' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'p-seguros',
        accept: () => {
          this.guardar( registro );
        },
        reject: () => {
        }
      } );
      return;
    }
    this.guardar( registro );
  }

  guardar( registro: any ) {
    this.carInformacionInicial = true;

    const listaProductosSeguros = this.lisProductosSegurosTodos.filter(x =>
      x.idSeguro === registro.idSeguro && x.indicadorHabilitado
    );

   const  listaTipoDireccion = this.lisProductoSeguroTipoDireccion.filter(td =>
      td.idSeguro === registro.idSeguro && td.indicadorHabilitado);

    const listaPrincipal = listaProductosSeguros.map(x => {
      const existeTipoDireccion = listaTipoDireccion.find(td =>
        td.idProductoSeguro === x.idProductoSeguro && td.indicadorHabilitado
      );

      return {
        ...x,
        idTipoDireccion: existeTipoDireccion?.idTipoDireccion ?? null,
        tipoDireccion: existeTipoDireccion?.tipoDireccion ?? null
      };
    });


    const registroExistente = listaPrincipal.find(x =>
      x.idSeguro === registro.idSeguro &&
      x.idClaseVivienda === registro.idClaseVivienda &&
      x.idTipoDireccion === registro.idTipoDireccion
    );


    const debeCrearNuevoRegistro = !registroExistente;


    if (!debeCrearNuevoRegistro) {
      registro.idProductoSeguro = registroExistente.idProductoSeguro;

      this.serProductoSeguro.actualizar(registro).subscribe(() => {
        this.verificarGuardado(registro, false);
      });
    } else {
      this.serProductoSeguro.crear(registro).subscribe(r => {
        registro.idProductoSeguro = r.idProductoSeguro;
        this.verificarGuardado(registro, true);
      });
    }
  }

  verificarGuardado( registro: any, crear: boolean ) {
    forkJoin( this.actualizarTablas( registro, crear, this.lisProductoSeguroTipoDireccion, registro.idTipoDireccion ? [ registro.idTipoDireccion ] : [], 'idTipoDireccion', this.lisTipoDireccion, 'tipoDireccion', this.proSeguroTipoDireccionService, 'idProductoSeguroTipoDireccion' ),
      this.actualizarTablas( registro, crear, this.lisProductoSeguroTipoConstruccion, registro.idTipoConstruccion, 'idTipoConstruccionVivienda', this.lisTipoConstruccion, 'tipoConstruccionVivienda', this.proSeguroTipoConstruccionService, 'idProductoSeguroTipoConstruccion' ),
    ).subscribe( async l => {
      this.lisProductosSegurosTodos = await this.serProductoSeguro.listadoPorProducto( this.producto.idProducto ).toPromise();
      this.ordenarSeguros();
      this.cargarListado();
      this.cargarSeguros();
      this.cargarFormulario();
      this.formulario.markAsPristine();
      this.submitted = false;
      this.navServicio.setMesage( 1 );
      this.carInformacionInicial = false;
    } );
  }


  async actualizarTablas( registro: any, crear: boolean, lisProductoTipo: any[], campoFormulario: any[], llaveForeanea: string, lista: SelectItem[], transient: string, servicio: any, llavePrimaria: string ) {
    const regActualizar = [];
    const lisSeguro = !crear ? lisProductoTipo.filter( x => x.idProductoSeguro === registro.idProductoSeguro ) : [];
    campoFormulario?.forEach( e => {
      const existe = lisSeguro.find( x => x[ llaveForeanea ] === e );
      if ( existe && !existe.indicadorHabilitado ) {
        existe.indicadorHabilitado = true;
        regActualizar.push( existe );
      } else if ( !existe ) {
        const a = {} as any;
        a.idProductoSeguro = registro.idProductoSeguro;
        a[ llaveForeanea ] = e;
        a.indicadorHabilitado = true;
        const tipTransient = lista.find( y => y.value === e );
        a[ transient ] = tipTransient ? tipTransient.label : null;
        regActualizar.push( a );
      }
    } );

    lisSeguro.forEach( e => {
      if ( e.indicadorHabilitado && !campoFormulario.find( m => e[ llaveForeanea ] === m ) ) {
        e.indicadorHabilitado = false;
        regActualizar.push( e );
      }
    } );

    if ( regActualizar.length > 0 ) {
      const lisActualizado = await servicio.bulk( regActualizar ).toPromise();
      regActualizar.forEach( e => {
        if ( !e[ llavePrimaria ] ) {
          const item = lisActualizado.find( u => u[ llaveForeanea ] === e[ llaveForeanea ] );
          e[ llavePrimaria ] = item ? item[ llavePrimaria ] : null;
          lisProductoTipo.push( e );
        }
      } );
    }
    return;
  }

  cambiarHabilitado( productoSeguro: ProductoSeguroAnalizamos ) {
    this.conServicio.confirm( {
      message: this.navServicio.buscarMensaje( 'MSG_INHABILITAR' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'p-seguros',
      accept: () => {
        this.carInformacionInicial = true;
        productoSeguro.indicadorHabilitado = false;
        this.serProductoSeguro.actualizar( productoSeguro ).subscribe( e => {
          this.cargarListado();
          this.cargarSeguros();
          this.navServicio.setMesage( 2 );
          this.carInformacionInicial = false;
        } );
      }
    } );
  }

  get f() {
    return this.formulario.controls;
  }

  cambioInformacionAdicional( check: boolean ) {
    if ( !check ) {
      this.f.idTipoConstruccion.setValue( [] );
      this.f.idClaseVivienda.setValue( null );
      this.f.idTipoDireccion.setValue( null );
      this.f.idTipoOcupacion.setValue( null );
    }
  }

  deshabilitarNoEliminable(event: any) {
    if (event?.checked) {
      this.f.indicadorNoEliminable.setValue( false );
    }
  }

}
